import { Link } from 'react-router-dom';

export default function AboutPreviewSection() {
  return (
    <section className="py-20 bg-[#f7faf7]">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row items-center gap-14 lg:gap-20">
          {/* Left - Image */}
          <div className="w-full lg:w-1/2 flex-shrink-0">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20biotech%20laboratory%20scientist%20researcher%20working%20with%20natural%20herb%20ingredients%20in%20modern%20clean%20lab%20environment%2C%20green%20plants%20bottles%20supplements%20on%20desk%2C%20bright%20natural%20lighting%2C%20high%20quality%20commercial%20photography%20for%20health%20food%20brand&width=720&height=540&seq=about-preview-01&orientation=landscape"
                alt="康永生技 關於我們"
                className="w-full h-[260px] sm:h-[340px] lg:h-[440px] object-cover object-top rounded-2xl"
              />
              {/* Float badge */}
              <div className="absolute bottom-6 left-6 bg-white rounded-xl px-5 py-4 flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-green-50 rounded-lg">
                  <i className="ri-shield-check-line text-[#4CAF50] text-xl" />
                </div>
                <div>
                  <p className="text-[#1a2e1a] font-bold text-[1rem]">HACCP 認證廠房</p>
                  <p className="text-gray-400 text-[0.8125rem]">符合國際標準製造</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right - Text */}
          <div className="w-full lg:w-1/2">
            <span className="inline-block bg-green-50 text-[#4CAF50] text-[0.875rem] font-medium px-4 py-1.5 rounded-full mb-5 border border-green-200">
              關於康永
            </span>
            <h2 className="text-[#1a2e1a] font-bold leading-tight mb-6">
              生技代工的<br />最佳合作夥伴
            </h2>
            <p className="text-gray-600 text-[1.0625rem] leading-[1.75] mb-8">
              康永生技成立多年，以自然為健康根本，專注於保健食品的代工生產服務，從原料採購到成品出貨，每個環節嚴格把關，協助品牌將創意轉化為合法的市場產品
            </p>

            <div className="grid grid-cols-2 gap-5 mb-10">
              {[
                { icon: 'ri-building-line', label: '堅持自然選材' },
                { icon: 'ri-test-tube-line', label: '創造健康三贏' },
                { icon: 'ri-global-line', label: '整合式代工生產' },
                { icon: 'ri-customer-service-line', label: '法規細節把控' },
              ].map((item) => (
                <div key={item.label} className="flex items-center gap-3">
                  <div className="w-9 h-9 flex items-center justify-center bg-green-50 rounded-lg flex-shrink-0">
                    <i className={`${item.icon} text-[#4CAF50] text-lg`} />
                  </div>
                  <span className="text-[#1a2e1a] font-medium text-[0.9375rem]">{item.label}</span>
                </div>
              ))}
            </div>

            <Link
              to="/about"
              className="whitespace-nowrap inline-flex items-center gap-2 bg-[#4CAF50] hover:bg-[#43a047] text-white font-semibold text-[1rem] px-8 py-4 rounded-full transition-all duration-300 cursor-pointer"
            >
              了解更多
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
